import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class PolygonZkEvm extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("polygonZkEvm", _placeholderMode);
    }

    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const height = 70;
        const x00 = height * Math.tan(25 * Math.PI / 180);
        const htl2 = x00 + 10;

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        if(!coreMode) {
            const idOB = `circleOutbounding_${this.chainIdName}`;
            const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
            const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
            obCircle.id = idOB;
            obCircle.setAttribute("d", `${dOB}`);
            defs.appendChild(obCircle);
        }

        const points: Array<Point> = [ new Point(0, 70),
            new Point(x00, 0),
            new Point(0, -70),
            new Point(-x00, 0)
        ];
        const polygonId = `polygon_50deg_70_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        const signData = `M22.6384 22.0384C22.0849 21.193 21.3654 21.193 20.7565 22.0384L16.4391 28.5195L13.5055 32.7463L9.18819 39.2274C8.63469 40.0728 7.91512 40.0728 7.30627 39.2274L3.87454 34.1552C3.32104 33.3098 2.93357 31.76 2.93357 30.0693V20.0659C2.93357 18.3752 3.26569 16.8254 3.87454 15.98L7.25092 11.0488C7.80442 10.2034 8.52399 10.2034 9.13284 11.0488L12.5092 15.98C13.0627 16.8254 13.4501 18.3752 13.4501 20.0659V26.547L16.3838 22.1793V15.6983C16.3838 14.0075 16.0516 12.4577 15.4428 11.6124L9.18819 2.31347C8.63469 1.46812 7.91512 1.46812 7.30627 2.31347L0.94096 11.6124C0.332104 12.4577 0 14.0075 0 15.6983V34.4368C0 36.1276 0.332104 37.6775 0.94096 38.5229L7.30627 47.8218C7.85977 48.6672 8.57934 48.6672 9.18819 47.8218L13.5055 41.4817L16.4391 37.114L20.7565 30.7737C21.31 29.9284 22.0295 29.9284 22.6384 30.7737L26.0148 35.7051C26.5682 36.5502 26.9557 38.1 26.9557 39.7909V49.7942C26.9557 51.485 26.6236 53.0349 26.0148 53.88L22.6384 58.9521C22.0849 59.7975 21.3654 59.7975 20.7565 58.9521L17.3801 54.0209C16.8266 53.1755 16.4391 51.6256 16.4391 49.9351V43.4541L13.5055 47.8218V54.3028C13.5055 55.9933 13.8376 57.5432 14.4465 58.3886L20.8118 67.6875C21.3654 68.5329 22.0849 68.5329 22.6938 67.6875L29.059 58.3886C29.6125 57.5432 30 55.9933 30 54.3028V35.5641C30 33.8733 29.6679 32.3234 29.059 31.4782L22.6384 22.0384Z`;
        const polygonIdSign = `polygon_sign_${this.chainIdName}`;
        const polygonSign = SvgUtils.createPath(polygonIdSign, signData, true, ``, "", 0);
        defs.appendChild(polygonSign);

        svg.appendChild(defs);
        
        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // polygon-1
        this.addUsePartToGroup(group, polygonId, `translate(0 -80)`, this.getColorHex(1, 2, 3), "", 0);
        // polygon-2
        this.addUsePartToGroup(group, polygonId, `translate(${htl2} 0)`, this.getColorHex(4, 5, 6), "", 0);
        // polygon-3
        this.addUsePartToGroup(group, polygonId, `translate(0 80)`, this.getColorHex(7, 8, 9), "", 0);
        // polygon-4
        this.addUsePartToGroup(group, polygonId, `translate(-${htl2} 0)`, this.getColorHex(10, 11, 12), "", 0);

        // sign-left
        this.addUsePartToGroup(group, polygonIdSign, `translate(-90 -29.5) scale (-1, 1) rotate(15)`, this.getColorHex(13, 14, 15), "", 0);
        // sign-right
        this.addUsePartToGroup(group, polygonIdSign, `translate(90 -29.5) rotate(15)`, this.getColorHex(16, 17, 18), "", 0);
        
        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);
        return svg;
    }

}